import { proxy } from 'valtio'

export const authDialogState = proxy({
  open: false as boolean,
})
